import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import {
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';
import { layoutGap } from '../../../theme/theme';

interface FindReplaceDialogHeaderProps {
  readonly previewOnly: boolean;
  readonly onClose: () => void;
}

export const FindReplaceDialogHeader: React.FC<FindReplaceDialogHeaderProps> = ({
  previewOnly,
  onClose,
}) => {
  const theme = useTheme();
  const surfaceBorder = alpha(theme.palette.common.white, 0.06);

  return (
    <DialogTitle
      id="find-replace-dialog-title"
      sx={{
        px: 2,
        py: 1.25,
        borderBottom: `1px solid ${surfaceBorder}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Stack direction="row" spacing={layoutGap.row} alignItems="center">
        <FindReplaceIcon sx={{ fontSize: '1rem', color: theme.palette.primary.main }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '0.8125rem' }}>
          Find and replace
        </Typography>
      </Stack>
      <IconButton
        onClick={onClose}
        aria-label="Close"
        size="small"
        disabled={previewOnly}
        sx={{
          width: 26,
          height: 26,
          color: theme.palette.text.secondary,
          '&:hover': { color: theme.palette.text.primary },
        }}
      >
        <CloseIcon sx={{ fontSize: '0.875rem' }} />
      </IconButton>
    </DialogTitle>
  );
};
